module.exports = __webpack_public_path__ + "static/media/Stopwatch.0f2906b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stopwatch.svg
// module id = 304
// module chunks = 0